import { CrudBase } from "../../crud";
import { BasicCrud } from "../../../utils/interfaces/crud/imp/crud-basic";
import { QuestionnaireSectionModel, QuestionnaireSectionCreateModel } from "../../../models/questionnaire-section";
//import { QuestionnaireQuestionModel } from "../../../models/questionnaire-question";


class _QuestionnaireSectionController extends CrudBase {
    createModel = QuestionnaireSectionCreateModel;

    constructor() {
        super({
            name: "questionnaire-section",
            modules: {
                crud: new BasicCrud()
            },
            model: QuestionnaireSectionModel
        });
    }

    onReady() {
        this.actions = this.repo.questionnaire_section;
    }

    async create(questionnaireId) {
        this.loading = true;
        this.formData.questionnaireId = questionnaireId;
        this.formData.title = "New Section";

        return await this.execute(this.actions.create, this.formData);
    }

    onEdit(item) {
        this.formData = new this.defaultModel(item);
        this.app.$router.push(`${this.routes.edit}${item.id}/${item.questionnaireId}`)
    }

    async update() {
        await this.execute(this.actions.update, this.formData, `?id=${this.formData.id}`);
    }

    async addQuestion() {
        var question_ctrl = this.app.get_controller("questionnaire_question");
        var response = await question_ctrl.create(this.formData);

        this.formData.questionnaireQuestions.push(response.data);

        this.app.$refs.confirmationDialog.showDialog({
            title: `Question Created!`,
            message: `Would you like to edit this question now?`,
            callback: "goToQuestion",
            callbackData: response.data,
            controller: "questionnaire_section"
        });
    }

    async promptDelete(item) {
        this.app.$refs.confirmationDialog.showDialog({
            title: `Delete Section?`,
            message: `Are you sure you wish to delete this questionnaire section?`,
            callback: "deleteItem",
            callbackData: item,
            controller: "questionnaire_section"
        });
    }

    async deleteItem(item) {
        var questionnaire_ctrl = this.app.get_controller("questionnaire");

        await this.execute(this.actions.delete, null, `?id=${item.id}`);

        let sections = questionnaire_ctrl.formData.questionnaireSections;

        sections.splice(sections.indexOf(item), 1);
    }

    getSection(sectionId) {
        var questionnaire = this.app.get_controller("questionnaire").formData;
        this.formData = questionnaire.questionnaireSections.find(el => el.id == sectionId);
    }

    goToQuestion(question) {
        this.app.$router.push(`${this.app.$route.path}/Question/${question.id}`);
    }
}

export const QuestionnaireSectionController = new _QuestionnaireSectionController();